module.exports = __webpack_public_path__ + "607650670afc9f6901f47905cdf4d212.svg";